module.exports = __webpack_public_path__ + "img/body-3-lg.12adc763.png";